import { useEffect, useMemo, useRef } from 'react';
import { useLocale } from 'next-intl';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

//* Components
import Icon from '@/components/Icon';
import Text from '@/components/Text';
import ItemService from './ItemService';
import Container from '@/components/Container';
import useTrigger from '@/components/Animation/useTrigger';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

//* Styles
import ServiceStyle from './style';

//* Data
import { dataService } from '@/data';

const ServiceSection = ({ hideTitle, hideItem }) => {
	const lang = useLocale();
	const swiperRef = useRef();
	const titleRef = useRef();
	const styleRef = useRef();

	const itemsService = useMemo(() => {
		return dataService[lang].item.map((item) => {
			return item.content.map((elem) => {
				return elem.url == hideItem ? null : (
					<SwiperSlide key={elem.url}>
						<div className='inner-wrapper-slide'>
							<ItemService {...elem} />
						</div>
					</SwiperSlide>
				);
			});
		});
	}, []);

	useEffect(() => {
		[...swiperRef.current.children[0].children].map((item, i) => {
			item.children[0].style = `--delayItem: ${i} `;
		});
		const trigger = useTrigger({
			ref: titleRef.current,
			documentPercent: 70,
			onEnter: () => {
				titleRef.current.children[0].classList.add('active');
				styleRef.current.classList.add('active');
			},
		});
		return () => {
			trigger();
		};
	}, []);

	return (
		<ServiceStyle ref={styleRef}>
			<Container isSection>
				<div className='wrapper-service'>
					{hideTitle ? null : (
						<div className='wrapper-title-nav'>
							<Text
								ref={titleRef}
								tag={'h2'}
								className={'h3 font-montserrat-arm-medium title-service-text uppercase text-primary-color'}>
								<TextAnimation
									delay={0.2}
									text={dataService[lang].title}
								/>
							</Text>

							<div className='wrapper-navigation'>
								<div className='swiper-button-prev'>
									<Icon
										className={'arrow left-arrow text-primary-color'}
										name={'arrowLeft'}
									/>
								</div>

								<div className='swiper-button-next'>
									<Icon
										className={'arrow right-arrow text-primary-color'}
										name={'arrowRight'}
									/>
								</div>
							</div>
						</div>
					)}

					<div className='inner-wrapper-service'>
						<Swiper
							ref={swiperRef}
							slidesPerView={'auto'}
							modules={[Autoplay, Navigation]}
							// autoplay={{
							// 	delay: 5000,
							// 	disableOnInteraction: false,
							// }}
							// loop={true}
							navigation={{
								prevEl: '.swiper-button-prev',
								nextEl: '.swiper-button-next',
							}}>
							{itemsService}
						</Swiper>
					</div>
				</div>
			</Container>
		</ServiceStyle>
	);
};

export default ServiceSection;
